import { useContext } from 'react';
import HttpAxios from '../../hooks/http';
import { AppContext } from '../../context/App-context';
import { QuestionsContext } from '../../context/Questions';
import enviroment from '../../../enviroments/enviroment';
import { useQuestionsMe } from '../../hooks/questionsme';
import { EErrorMsg, ESuccessMsg } from '../../statics/controls';
import './actions-apply.scss';

interface IActionsApply {
    isInline?: boolean;
}

const ActionsApply = ({ isInline }: IActionsApply) => {
    const { changeIsLoading, changeSnackBar } = useContext(AppContext);
    const { changeProgressQuestions } = useContext(QuestionsContext);
    const [questionsMe, setQuestionsMe] = useQuestionsMe();
    const { canApply, changeCanApply, changeShowModalApply } =
        useContext(QuestionsContext);
    const getProgress = () => {
        changeIsLoading(true);
        HttpAxios.post('/forms/save_status', {})
            .then((res: any) => {
                const { err, response } = res?.data || {};
                if (err) {
                    changeSnackBar(EErrorMsg.generic);
                    changeIsLoading(false);
                    setQuestionsMe({
                        avancepostulacion: 0,
                        total_preguntas: 0,
                        total_respondidas: 0,
                    });
                } else {
                    const {
                        avancepostulacion = 0,
                        total_preguntas = 0,
                        total_respondidas = 0,
                    } = response || {};
                    changeProgressQuestions(avancepostulacion);
                    changeCanApply(avancepostulacion >= enviroment.limitApply);
                    changeSnackBar(ESuccessMsg.saved);
                    setQuestionsMe({
                        avancepostulacion,
                        total_preguntas,
                        total_respondidas,
                    });
                    changeIsLoading(false);
                }
            })
            .catch(() => {
                changeSnackBar(EErrorMsg.generic);
                changeIsLoading(false);
            });
    };

    const publish = () => {
        changeShowModalApply(true);
    };

    return isInline ? (
        <button
            className="button buttonComplement"
            type="button"
            onClick={getProgress}
        >
            Guardar avance
        </button>
    ) : (
        <>
            <button
                className="button buttonComplement"
                type="button"
                onClick={getProgress}
            >
                Guardar avance
            </button>
            <button
                className="button buttonSecondary relative ActionsTrigger"
                type="button"
                onClick={publish}
                disabled={!canApply}
            >
                Enviar postulación
                {!canApply && (
                    <span className="ActionsTooltip">
                        La postulación se activará al {enviroment.limitApply}%
                        de avance
                    </span>
                )}
            </button>
        </>
    );
};

export default ActionsApply;
